<template>
  <div class="md-layout _singleTask">
    <div class="md-autocomplete-loading" v-if="isBusy">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>
    <div class="_portalRoot">

      <portal to="sidepanel-portal-feed">

        <div class="_commentBox" :class="{ active: showEditorFlag }">
          <div v-show="showEditorFlag">
            <div class="_commentBox__form">
              <TinyMceEditor v-model="comment.body" theId="comment" :mentionArr="userListItems" @itemSelected="commentItemSelected"/> 
              <div class="md-space-between">
                <md-card-actions md-alignment="left">
                  <md-button class="md-simple md-just-icon _attachFileBtn">
                    <i class="material-icons" v-on:click="onUpload()">attachment</i>
                  </md-button>
                  <span v-if="attachmentData == null">Browse or attach file here</span>
                  <!-- <div class="md-layout-item" v-if="attachmentData">
                    <div class="md-layout md-gutter md-alignment-center">
                      <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" >
                        <div v-show="attachmentData.file.name" class="attchment-card">
                          <div class="attchment-container">{{ attachmentData.file.name }} 
                            <div>{{ attachmentData.description }}</div> ({{ attachmentData.file.size | kb }} kb)
                            <div>{{ attachmentData.type }}</div>
                            <button type="button" class="attachment-button" title="Remove" @click="removeFile()" >x</button>
                          </div>
                          <md-checkbox 
                            class="attachment-area__checkbox" 
                            v-show="$Session && $Session.isInternalGroupMember"
                            v-model="isInternal"
                          >Internal</md-checkbox>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </md-card-actions>
                <md-card-actions md-alignment="right">
                  <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="comment.internal">Internal</md-checkbox>
                  <md-button class="md-sm md-success" :disabled="comment.body==''" @click="sendComment()"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i> Submit</md-button>
                  <md-button class="md-sm md-danger"  @click="closeEditor('comment')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
                </md-card-actions>
              </div>
            </div>
          </div>
          <div v-show="!showEditorFlag" @click="showEditor('comment')">
            Click to write your comment.
          </div>
        </div>

        <TaskFeed
          :items="feedActive"
          :taskId="$route.params.id"
          :userListItems="userListItems"
          :task="recordData"
        />
        
        <md-button
          class="md-sm md-primary"
          @click="loadNextFeedData"
          title="Load More"
          v-if="feedHasMore()"
        >Load More</md-button>
        
      </portal>

      <!-- Upload Dialog -->
      <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
        <md-dialog-title>Attachment</md-dialog-title>
        <md-dialog-content>
          <CommentAttachmentsForm
            :docTypes="docTypes"
            :model="attachmentData"
            @success="onUploadSuccess"
          />
        </md-dialog-content>
      </md-dialog>

    </div>

    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon>
      </div>
      <div v-if="recordData && recordData.case && recordData.case.services && recordData.case.services.items && recordData.case.services.items[0] && recordData.case.services.items[0].service">
        <h1 class="md-title compact content-wrap">
          <a :href="'#/services/' + recordData.case.services.items[0].service.id" class="icon-color">{{ recordData.case.services.items[0].service.name }}</a></h1>
        <h2 v-if="recordData.case.services.items[0].service && recordData.case.services.items[0].service.merchantNumber" class="compact">MID: {{ recordData.case.services.items[0].service.merchantNumber }}</h2>
        <br/>
        <h3 class="compact"><span class="sub-header content-wrap"> Task: {{recordData.subject}}</span></h3>
        <h4 v-if="recordData.case" class="compact content-wrap">
          <a :href="'#/cases/' + recordData.case.id" class="sub-header">Case: {{recordData.case.subject}}</a></h4>
      </div>      
      <div v-else>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.subject : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">

      <md-tabs md-sync-route class="topNavTabs">
        <md-tab id="tab-account" md-label="Task" :to="recordPath" exact>
          <CustomTaskForm
            :atShowAuditLog="onShowAuditLog"
            :update="updateForm"
            :form="form"
            :$v="$v"
            :formConfig="formConfig"
            :recordData="recordData"
            :groupIndex="groupIndex"
            :orderIndex="orderIndex"
            :taskCrud=true
            :headerColor="headerColor"
          ></CustomTaskForm>
          <md-dialog :md-active.sync="auditLogDialog">
            <md-dialog-title>Audit Log</md-dialog-title>
            <md-dialog-content>
              <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"
              ></AuditLogDialog>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="auditLogDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>

        <!-- <div class="md-layout-item md-size-100">
          <div v-if="formConfig.pageMode != 'new'">
            <div>
              <collapse class="collapse-head"
                :collapse="['Feed']"
                icon="keyboard_arrow_down"
                color-collapse="success _collapseFeed"
                :defaultActive="defaultActiveCollapseIndex"
              >
                <template slot="md-collapse-pane-1">             
                  <TaskFeed 
                    :items="feedActive" 
                    :taskId="$route.params.id"
                    :userListItems="userListItems"
                  />
                  <md-button 
                    class="md-sm md-primary" 
                    @click="loadNextFeedData" 
                    title="Load More" 
                    v-if="feedHasMore()"
                  >Load More</md-button> 
                </template>
              </collapse>
            </div>
          </div>
        </div> -->
          
        <!-- <div class="md-layout-item">
          <div class="commentBox">
            <div v-show="showEditorFlag">
              <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="comment.internal">Internal</md-checkbox>
              <div style="padding:10px">
              <TinyMceEditor v-model="comment.body" theId="comment" :mentionArr="userListItems" @itemSelected="commentItemSelected"/> 
              <md-card-actions md-alignment="right">
                <md-button class="md-sm md-success" :disabled="comment.body==''" @click="sendComment()"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i> Submit</md-button>
                <md-button class="md-sm md-danger"  @click="closeEditor('comment')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
              </md-card-actions>
              </div>
            </div>
            <div v-show="!showEditorFlag" @click="showEditor('comment')">
              Click to write your comment.
            </div>
          </div>
        </div> -->
        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <CustomTaskForm
        :update="updateForm"
        :form="form"
        :$v="$v"
        :formConfig="formConfig"
        :recordData="recordData"
        :groupIndex="groupIndex"
        :orderIndex="orderIndex"
        :taskCrud=true
        :headerColor="headerColor"
      ></CustomTaskForm>
    </div>
    <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
      <span>{{ snackbarMsg }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import TaskMixin from "@/pages/Tasks/Mixins/TaskMixin";
import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
import moment from 'moment';
import TaskFeed from '@/components/TaskFeed';
import { Tabs } from "@/components";
import TinyMceEditor from '@/components/Editor/TinyMceEditor';  
import { Collapse } from "@/components";
import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
import Amplify, { Auth, API, graphqlOperation, JS } from "aws-amplify";
import * as queries_custom from "@/graphql/queries_custom";
import Attachments from '@/components/DynamicForm/Attachments/Attachments';
const AttachmentsMixin = {
  methods: {
    getDocTypes: Attachments.methods.getDocTypes,
  }
};

export default {
  name: "task",
  mixins: [TaskMixin, AttachmentsMixin],
  components: {
    AuditLogDialog,
    TaskFeed,
    Tabs,
    TinyMceEditor,
    Collapse,
    CommentAttachmentsForm
  },
  data() {
    return {
      activeModel: {},
      isUploadDialogOpen: false,
      docTypes: [],
    };
  },
  async mounted() {
    this.docTypes = await this.getDocTypes();
  },
  methods: {
      /**
       * Show attachment upload form
       * @returns {Void}
       */
      onUpload() {
        this.$set(this, 'activeModel', {});
        this.isUploadDialogOpen = true;
      },
      /**
       * Attachment was successfully added or updated
       * Close dialog
       * @returns {Void}
       */
      onUploadSuccess(attachmentData) {
        this.isUploadDialogOpen = false;
        this.attachmentData = attachmentData;
        console.log("attachmentData ", attachmentData);
      },
      removeFile(){
        this.attachmentData = null;
      },    
    }
};
</script>

<style lang="scss">
.md-tabs .md-tabs-navigation {
  padding-left: 15px;
  color: black;
  display: none;
  .md-tab-nav-button.md-button {
    color: black !important;

    &.active {
      color: black !important;
      border-bottom: 2px solid black;
    }
  }
}

.md-content .md-tabs-container .md-tab > .md-layout-item {
  padding-left: 0;
  padding-right: 0;
}

.md-field.md-error.md-theme-default label {
  color: #f44336 !important;
}

/*
ATLAS-1009
*/

form:not(.md-warning) .vue-grid-item-content {
  padding-left: 0;
}

._taskForm__step._taskView__steps__step::before, 
._taskForm__step._taskView__steps__step::after {
  content: normal;
}

._taskForm__step._taskView__steps__step .md-checkbox-label {
  display: none;
}

._taskForm__step .md-checkbox {
  margin: 0;
  margin-top: 5px;
}

#taskTable.table.taskTable {
  width: 100%;
}

.taskTable th {
  padding: 10px;
}

.md-layout-item._taskLayoutCard {
  padding-left: 10px; 
  padding-right: 30px;
}

._caseTask #basic .vue-grid-item-content,
._caseTask #targets .vue-grid-item-content {
  padding-bottom: 0;
}

._caseTask #targets .md-field {
  margin-top: 0;
}

@media (min-width: 1200px) {
  ._singleTask ._singleTask__form__rootLayout,
  ._singleTask ._taskLayoutCard {
    max-width: 50%;
    min-width: 50%;
  }
}

.md-space-between {
  display: flex;
  justify-content: space-between;
}

.md-layout-item {
  padding: 10px !important;
}

.attchment-card {
    margin-bottom: 0px !important;
}

.md-layout-item .md-layout, .md-layout-item {
  width: auto !important;
}
</style>
